import Link from "next/link";

export default function FigureTile({ id, slug, displayName, portraitUrl, portraitAlt }) {
  return (
    <div className="cursor-pointer hover:underline" id={id}>
      <Link
        href={{
          pathname: "/figures/[slug]",
          query: { slug, stop: 0 },
        }}
        prefetch={false}
      >
        <a>
          <img
            src={portraitUrl}
            alt={displayName}
            className="w-full h-auto max-w-xs"
            width="200"
            height="200"
          />
          <div className="h-fit text-gamma font-bold uppercase mt-2">{displayName}</div>
          {portraitAlt && (
            <div className="text-tiny text-gray-400 mt-1">{portraitAlt}</div>
          )}
        </a>
      </Link>
    </div>
  );
}
